'use client'

import React from 'react'
import type { Testimonial } from '@/payload-types'
import { cn } from '@/utilities/ui'

interface TestimonialContentProps {
  testimonial: Testimonial
  className?: string
}

export const TestimonialContent: React.FC<TestimonialContentProps> = ({
  testimonial,
  className,
}) => {
  const customer = typeof testimonial.customer === 'object' ? testimonial.customer : null

  return (
    <div
      className={cn(
        'flex flex-col justify-between rounded-[16px] bg-white border border-[#d1ccbe] p-[22px]',
        className,
      )}
    >
      <div className="flex flex-col h-full">
        {/* Testimonial Quote */}
        <div className="flex-1 flex items-center">
          <blockquote className="font-['Newsreader'] font-light text-[26px] lg:text-[42px] leading-[34px] lg:leading-[52px] italic text-black">
            &ldquo;{testimonial.testimonial}&rdquo;
          </blockquote>
        </div>

        {/* Attribution */}
        <div className="mt-auto">
          <div className="font-['Hanken_Grotesk'] font-medium text-[18px] leading-5 text-black text-right">
            <div>{testimonial.name},</div>
            <div className="whitespace-pre-wrap">{testimonial.role}  {customer?.companyName || 'Civo'}</div>
          </div>
        </div>
      </div>
    </div>
  )
}